import type { BaseTableList, BaseTableListItem } from './types';

export const isTableList = (
  row: BaseTableListItem | BaseTableList
): row is BaseTableList => 'isList' in row && row.isList;
